// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aD8A","left":"styles_left__2GtJ8"};